﻿import React, { createContext, useState, useMemo } from "react";

export const initBookingFlowContext = {
	activeStep: 0,
	availableSteps: {
		onlineBooking:      { index: 0 },
		login:              { index: 1 },
		createAccount:      { index: 2 },
		addVehicle:         { index: 3 },
		documentUpload:     { index: 4 },
		orderOverview:      { index: 5 },
		orderConfirmation:  { index: 6 }
  },
}

export const BookingFlowContext = createContext(null)

export const BookingFlowContextProvider = (props) => {
  const config = props.appConfig ?? {};
  const urlParams = new URLSearchParams(window.location.search);
  const fId = urlParams.get('fId') ?? urlParams.get('fid');
  const type = urlParams.get('T') ?? urlParams.get('t') ?? '1';

  const sessionName = `__aimo-booking-flow__${fId}__${type}`;
  const expiry = 1000 * 60 * 60;

  const getWithExpiry = (key) => {
	  const itemStr = sessionStorage.getItem(key);
	  if (itemStr) {
	    const item = JSON.parse(itemStr);
	    const now = new Date();
      if (item.expiry && item.expiry > now.getTime()) {
        delete item.expiry;
	      return item;
      }
      if (!item.expiry) return item;
    }
    Object.keys(sessionStorage).forEach((key) => {
      if (key.includes('__aimo-booking-flow')) sessionStorage.removeItem(key);
    });
    return null;
  }
  const browserBookingFlowState = getWithExpiry(sessionName);

  if (process.env.NODE_ENV !== 'production') {
    //DEVELOPMENT SETTINGS
    initBookingFlowContext.useMockedData = false;
    initBookingFlowContext.useMockedLogin = false;

    //initBookingFlowContext.availableSteps.onlineBooking.formData = {"date":{"date":"12/31/2020","required":true,"elementType":"date"},"productSelection":{"item":{"Zone":"Citygaraget, Mäster Samuelsgatan 61, övre plan","ZoneId":"SE-8500112","Text":"7x24 Reserverad p-plats 3861.25 SEK","OverviewText":"7x24 Reserverad p-plats","Id":"13690","Type":"Reserved","ZoneAndProduct":"SE-8500112-13690","MonthlyPrice":"3861.25","QuarterlyPrice":"11583.75","HalfYearlyPrice":null,"AnnualPrice":null,"Currency":"SEK","ExtraFee":null,"Description":"The key will be used at check-in, a security deposit of SEK 250 will be added (reserved by customer service). Please note that if availability is not in stock, your reservation will be canceled.", "PhysicalZoneId":"SE-8500112","MaxSalesAmount":"3","ProductSubType":"SeasonTicket"},"required":true,"elementType":"select"},"numberOfParkingSpots":{"number":1,"elementType":"number"},"paymentSelection":{"item":{"text":"Monthly","currency":"SEK","optionPrice":"3861.25","id":"5b6cc789-365f-4483-848a-ab429c30ddaf"},"elementType":"radio"},"spotSelection":[{"item":{"ParkingSpace":{"Name":"Select spot","Uid":"00000000-0000-0000-0000-000000000000"}}}]}
    //initBookingFlowContext.availableSteps.addVehicleReserved.formData = [{"index":0,"registrationNumber":"ABC111","descriptionText":""},{"index":1,"registrationNumber":"ABC222","descriptionText":""},{"index":2,"registrationNumber":"ABC333","descriptionText":""}];
    //initBookingFlowContext.availableSteps.addVehicleUnreserved.formData = [{"index":0,"registrationNumber":"ABC444","descriptionText":""},{"index":1,"registrationNumber":"ABC555","descriptionText":""},{"index":2,"registrationNumber":"ABC666","descriptionText":""}];
  }

	const [bookingFlowContext, setBookingFlowContextTmp] = useState(() => {
      const expectedStepKeys = Object.keys(initBookingFlowContext.availableSteps);
      const persistedIsCompatible = browserBookingFlowState
        && browserBookingFlowState.availableSteps
        && expectedStepKeys.every(k => browserBookingFlowState.availableSteps[k] !== undefined);

      const currentState = persistedIsCompatible
        ? { ...browserBookingFlowState, ...config }
        : { ...initBookingFlowContext, ...config };
      return currentState;
    }
  )

    const setBookingFlowContext = (state) => {
        const now = new Date();
        const item = { ...state, expiry: now.getTime() + expiry };
        sessionStorage.setItem(sessionName, JSON.stringify(item));
        // clean the local Storage at the Order Overview step
        if (state.activeStep == state.availableSteps.orderOverview.index) {
            localStorage.removeItem("validUnlockCode");
            localStorage.removeItem("validUnlockPmcId");
        }
        if (state.activeStep > bookingFlowContext.activeStep) {
            history.pushState({ activeStep: state.activeStep }, document.title);
        }
        setBookingFlowContextTmp(state);
    }

	const bookingFlowState = useMemo(() => ({ bookingFlowContext, setBookingFlowContext }), [bookingFlowContext, setBookingFlowContext]);

	return (
		<BookingFlowContext.Provider value={bookingFlowState}>
			{props.children}
		</BookingFlowContext.Provider>
	)
}
